export default __webpack_public_path__ + "static/media/upgrade-report8.cbc5aa8d.png";